import { makeStyles, createStyles } from '@material-ui/core/styles';
import { TextColors, SecondaryColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const darkTheme = {
  root: {
    color: TextColors.light,

    '& a, a:not(:hover)': {
      color: SecondaryColors.main,
    },

    '& a:hover': {
      color: SecondaryColors.light,
    },
  },
  default: {
    '& h5': {
      color: SecondaryColors.main,
    },

    '& p': {
      color: hexToRGBA(TextColors.light, TextOpacities.light1),

      '& bold, strong, b, s': {
        color: TextColors.light,
      },
    },
  },
};

const lightTheme = {
  root: {
    color: TextColors.dark,

    '& a, a:not(:hover)': {
      color: SecondaryColors.dark,
    },

    '& a:hover': {
      color: SecondaryColors.main,
    },
  },
  default: {
    '& h5': {
      color: SecondaryColors.dark,
    },

    '& p': {
      color: hexToRGBA(TextColors.dark, TextOpacities.dark1),

      '& bold, strong, b, s': {
        color: TextColors.dark,
      },
    },
  },
};

export default makeStyles(
  (muiTheme) =>
    createStyles<any, any>({
      root: {
        '&.light-theme': lightTheme.root,
        '&.dark-theme': darkTheme.root,
        width: '100%',

        '& *': {
          marginTop: 0,
          marginBottom: 0,
          wordBreak: 'break-word',
        },

        '& h1, h2, h3, h4, h5, h6, p': {
          '&, & *': {
            color: 'inherit',
          },
        },

        '& a, a:not(:hover)': {
          textDecoration: 'none',
        },

        '& a:hover': {
          textDecoration: 'underline',
        },
      },
      default: {
        '&.light-theme': lightTheme.default,
        '&.dark-theme': darkTheme.default,
        ...muiTheme.typography.body1,

        '& h1, h2, h3, h4, h5, h6': {
          marginTop: 0,

          '& + *': {
            marginTop: '0 !important',
          },

          '& *': { fontWeight: 'inherit' },
        },

        '& p + *, p:not(:first-of-type)': {
          marginTop: '1.333333333em',
        },

        '& li + li': {
          marginTop: '0.222222222em',
        },

        '& img': {
          borderRadius: '4px',

          [muiTheme.breakpoints.down('sm')]: {
            display: 'block',

            '&:not([align="left"]):not([align="right"])': {
              marginLeft: '0 !important',
              marginRight: '0 !important',
            },

            '&[align="right"]': {
              margin: '1rem 0 1rem 3rem',
            },

            '&[align="left"]': {
              margin: '1rem 3rem 1rem 0',
            },
          },

          '&:not(:first-child)': {
            [muiTheme.breakpoints.down('sm')]: {
              marginTop: '1.333333333em',
            },
          },

          '&:not(:last-child)': {
            [muiTheme.breakpoints.down('sm')]: {
              marginBottom: '1.333333333em',
            },
          },

          '&[align="right"]': {
            margin: '1rem 0 1rem 5rem',
          },

          '&[align="left"]': {
            margin: '1rem 5rem 1rem 0',
          },
        },

        '& small': {
          ...muiTheme.typography.body2,
        },

        '& h1': {
          ...muiTheme.typography.h2,

          '&:not(:first-child)': {
            marginTop: '0.4em',
          },

          '&:not(:last-child)': {
            marginBottom: '0.266666667em',
          },
        },

        '& h2': {
          ...muiTheme.typography.h4,

          '&:not(:first-child)': {
            marginTop: '0.857142857em',
          },

          '&:not(:last-child)': {
            marginBottom: '0.285714286em',
          },
        },

        '& h3': {
          ...muiTheme.typography.h6,

          '&:not(:first-child)': {
            marginTop: '1.333333333em',
          },

          '&:not(:last-child)': {
            marginBottom: '0.785714286em',
          },
        },

        '& h4': {
          ...muiTheme.typography.subtitle2,

          '&:not(:first-child)': {
            marginTop: '0.96em',
          },

          '&:not(:last-child)': {
            marginBottom: '0.533333333em',
          },
        },

        '& h5': {
          ...muiTheme.typography.overline,
          fontWeight: 'bold',

          '&:not(:first-child)': {
            marginTop: '2em',
          },

          '&:not(:last-child)': {
            marginBottom: '1.333333333em',
          },
        },

        '& h6': {
          ...muiTheme.typography.caption,
          fontWeight: 'bold',

          '&:not(:first-child)': {
            marginTop: '2em',
          },

          '&:not(:last-child)': {
            marginBottom: '0.666666667em',
          },
        },

        '& a, a:not(:hover)': {
          textDecoration: 'none',
        },

        '& a:hover': {
          textDecoration: 'underline',
        },
      },
    }),
  { name: 'GenRichText' },
);
